export default "__VITE_ASSET__DVxBhrfn__"